/* eslint-disable jsdoc/check-param-names */
import React, { useEffect, useState } from 'react';
import { File } from 'olympe';
import { Button, ThemeProvider, Tooltip } from '@mui/material';
import { buttonsTheme } from './_theme.jsx';

/**
 * Component that display an image from the Olympe DC
 * @param {File} imageFile
 * @param {object} style
 * @returns {React.ReactElement}
 * @class
 */
export const Image = ({ imageFile, style }) => {
    const [imageUrl, setImageUrl] = useState();

    useEffect(() => {
        if (imageFile !== undefined && imageFile !== null) {
            imageFile.getContentUrl(setImageUrl);
        }
    }, [imageFile]);

    return (
        <div
            style={{
                backgroundImage: `url(${imageUrl})`,
                backgroundPosition: 'center',
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
                ...style,
            }}
        />
    );
};

/**
 * MUI Button using a DC image as an icon
 * @param {number} width 	The width of the button
 * @param {number} height	The height of the button
 * @param {number} padding	Padding between the button border and the icon
 * @param {File} image		The DC file used as button icon
 * @param {string} tooltipText			The text of the tooltip displayed when hovering
 * @param {string} tooltipPlacement		The placement of the tooltip (right, bottom, etc.)
 * @param {object} style				An object with additional css properties in the format used by MUI
 * @param {boolean} disabled			Whether the button is disabled
 * @param {function(React.SyntheticEvent): void} onClick		Callback when the button is clicked
 * @returns {React.ReactElement}
 * @class
 */
// prettier-ignore
export const ImageButton = ({width, height, padding = 8, image, tooltipText, tooltipPlacement = 'right', style, disabled = false, onClick = () => {}}) => {
	const button = <Button
		style={{
			width: `${width}px`,
			minWidth: `${width}px`,
			height: `${height}px`,
			padding: `${padding}px`,
			...style,
		}}
		color='primary'
		variant='contained'
		disabled={disabled}
		onClick={onClick}
	>
		<Image
			imageFile={image}
			style={{
				width: `${width-padding*2-2}px`,
				height: `${height-padding*2-2}px`,
			}}
		/>
	</Button>;

	let component;
	if(tooltipText) {
		component = <Tooltip
			title={tooltipText}
			placement={tooltipPlacement}
			classes={{tooltip: 'leftside-bar-tooltip'}}
			PopperProps={{
				modifiers: [{
					name: 'offset',
					options: {
						offset: [0, 0],
					},
				}],
			}}
		>
			{button}
		</Tooltip>;
	} else {
		component = button;
	}

	return <ThemeProvider theme={buttonsTheme}>{component}</ThemeProvider>;
}
